/* components\accordions.js */

import $ from 'jquery';

const $accordionToggle = $('.js-accordion-toggle');

$accordionToggle.on('click', function() {
  const $accordionToggle = $(this);
  const $accordion = $accordionToggle.closest('.js-accordion');
  const $accordions = $accordionToggle.closest('.js-accordions');
  if ($accordion.hasClass('is-toggled')) {
    $accordionToggle.attr({ 'aria-expanded': 'false' });
    $accordion.removeClass('is-toggled');
  } else {
    $accordions.find('.is-toggled').removeClass('is-toggled');
    $accordions
      .find('[aria-expanded="true"]')
      .attr({ 'aria-expanded': 'false' });
    $accordionToggle.attr({ 'aria-expanded': 'true' });
    $accordion.addClass('is-toggled');
  }
});
